module.exports = __webpack_public_path__ + "static/media/checkW.0665cc90.svg";